export interface Reference {
  id: string;
  name: string;
  category: string;
  description: string;
  logo: string;
}

export const defaultReferences: Reference[] = [];

const STORAGE_KEY = 'r3d_references';

export function getReferences(): Reference[] {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) return JSON.parse(saved);
    return defaultReferences;
  } catch {
    return defaultReferences;
  }
}

export function saveReferences(refs: Reference[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(refs));
}
